import { msg } from '@lingui/macro';
import { IconUserEdit } from '@tabler/icons-react';
import type { ImporterDescriptor } from '../../../descriptors/types';

const descriptor: ImporterDescriptor = {
  id: 'profileDataImport',
  status: 'active',
  category: 'other',
  icon: IconUserEdit,
  title: msg`Profile data import`,
  shortTitle: msg`Update producer profiles`,
  whenToUse: msg`Update profiles in your portfolio — producer bios, contact info, certifications, and visuals.`,
  outputDescription: msg`Updates partner / producer profile fields in your portfolio.`,
  intents: [
    'Update producer bios',
    'Refresh supplier contact details',
    'Update partner profile information',
    'Bulk-update producer profiles',
  ],
  keywords: [
    'profile',
    'producer',
    'partner',
    'bio',
    'contact',
    'company info',
    'about',
  ],
  synonyms: ['supplier info', 'winery profile', 'company profile'],
  inputHints: {
    fileTypes: ['xlsx'],
    sampleHeaders: ['Partner name', 'Email', 'Description', 'Website'],
    requiredColumns: ['Partner name'],
  },
};

export default descriptor;
